
import { SizeGroupTypeEnum } from 'app/back-office/shared/enum/size-group-type.enum.model';
import { ProductPricesSummary } from './product-card.model';

export class ProductPriceDetails {
  pricesBySizeId: { [key: number]: ProductPricesSummary; };
  pricesBySizeAndPalette: ProductPriceDetailBySizeAndPalette[];

  constructor(s?: Partial<ProductPriceDetails>) {
    if (s) {
      Object.assign(this, s);
    }
  }
}

export class ProductPriceDetailBySizeAndPalette {
  paletteId: number;
  prices: ProductPricesSummary;
  sizeGroup: SizeGroupTypeEnum;
}
